module.exports = __webpack_public_path__ + "static/img/slgwoman.4e14bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/20210918/slgwoman.jpg
// module id = I1pw
// module chunks = 1